import { Stack, styled } from '@/shared/ui';
import { Button } from '@/shared/ui/lib/Button';

export const StyledFormContainer = styled(Stack)`
  position: relative;
  width: 415px;
`;

export const StyledButton = styled(Button)`
  position: absolute;
  right: 0;
  top: 37px;
`;
